import React, { useMemo, useRef } from 'react';
import ReactQuill from 'react-quill-new';
import { undoChange, redoChange, formats } from "./toolbar";
import { Container, QuillGlobalStyles } from "./styles";
import "react-quill-new/dist/quill.snow.css";

const FONT_SIZES = [
  "10px", "12px", "14px", "16px", "18px", "20px",
  "24px", "28px", "32px", "36px", "48px", false,
];

const RichTextEditor = ({ value, onChange }) => {
  const quillRef = useRef(null);

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ size: FONT_SIZES }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ script: 'super' }, { script: 'sub' }],
        ['blockquote'],
        [{ align: [] }, { color: [] }, { background: [] }],
        ['link', 'image'],
        ['code-block', 'clean'],
      ],
      handlers: {
        undo: undoChange,
        redo: redoChange,
      },
    },
    imageResize: {
      modules: ['Resize', 'DisplaySize'],
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
  }), []);

  return (
    <Container>
      <QuillGlobalStyles />
      <ReactQuill
        ref={quillRef}
        value={value || ''}
        onChange={onChange}
        theme="snow"
        placeholder="Write something awesome..."
        modules={modules}
        formats={formats}
      />
    </Container>
  );
};

export default RichTextEditor;
